import React, {FunctionComponent, useContext} from "react";
import styled from "styled-components";
import "./VariantProposalLayout.scss";
import {InvoiceOption} from "../../models/item.model";
import {ThemeContext} from "../../context/ThemeContext";
import {Theme} from "../../models/theme.model";
import {CompanyContext} from "../../context/CompanyContext";
import {InvoiceContext} from "../../context/InvoiceContext";
import {VariantProposalCard} from "./VariantProposalCard";
import {getVariantCardPrice} from "../../utils/variant-card-price.util";

const StyledVariantProposalLayout = styled.section`
  &&& {
    border-bottom: 10px solid black;
    border-image: linear-gradient(0.25turn, ${({theme}) => theme.branding_dark_color}, ${({theme}) => theme.branding_light_color}, ${({theme}) => theme.branding_color});
    border-image-slice: 1;

    h1, h3 {
      color: ${({theme}) => theme.branding_dark_color};
    }
  }
`;

const StyledVariantProposalHeader = styled.div`
  &&& {
    background: ${({theme}) => theme.branding_color};

    &&& h1 {
      color: ${({theme}) => theme.text_light_color};
    }
  }
`;

interface VariantProposalLayoutProps {
    title: string;
    options: InvoiceOption[];
    highlightedOptionId: number | null;
    isInteractive: boolean;
    onSelectOption: (option: InvoiceOption) => void;
}

/**
 * Good/Better/Best option cards of the estimate in the "Variant Proposal" view mode
 * (ported from the standalone `variant_proposal` React app: GBBLayout + GBBItem).
 */
export const VariantProposalLayout: FunctionComponent<VariantProposalLayoutProps> = (props) => {
    const theme: Theme = useContext(ThemeContext).theme;
    const company = useContext(CompanyContext);
    const invoice = useContext(InvoiceContext);
    const shouldDisplayPhotoOutlet = props.options.some((option: InvoiceOption) => Boolean(option.photo_src));

    return (
        <StyledVariantProposalLayout theme={theme} className="variant-proposal-layout">
            <StyledVariantProposalHeader theme={theme} className="variant-proposal-layout-header">
                <h1 className="header-text">{props.title}</h1>
            </StyledVariantProposalHeader>

            <main className="variant-proposal-layout-main-content">
                {props.options.map((option: InvoiceOption) => {
                    return <VariantProposalCard key={option.id}
                                                option={option}
                                                price={getVariantCardPrice(company, invoice, option)}
                                                shouldDisplayPhotoOutlet={shouldDisplayPhotoOutlet}
                                                isHighlighted={option.id === props.highlightedOptionId}
                                                isDisabled={!props.isInteractive}
                                                onSelect={props.onSelectOption}/>;
                })}
            </main>
        </StyledVariantProposalLayout>
    );
};
